! function(module) {
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if (window.define) {
        define('common/masterJson',['ct_utils'], module)
    } else
        //>>excludeEnd("requireTmpl");
        module()

}(function() {

    var masterJson = {}

    return CT.masterJson = {
        get: function() {
            return masterJson[CT.settings.currentTab]
        },

        /**
         *
         * @param {Object} json - the master json
         * @param {Object} xhr - an xhr instance (for security purposes so that master json is not clobbered from outside)
         */
        set: function(json, xhr) {
            var currentTab = CT.settings.currentTab
            //if(Object.prototype.toString.call(json) === '[object Object]' && !masterJson[currentTab]) masterJson[currentTab] = json
            //else throw new Error('Master json for ' + currentTab + ' is already set!')
            masterJson[currentTab] = json
            return json
        },

        update: function(json, xhr) {
            for (var k in json.ht) {
                masterJson[CT.settings.currentTab].ht.push(json.ht[k])
            }
            //masterJson[CT.settings.currentTab].ht = json.ht
            return json
        },

        setFlightRank: function() {
            try {
                var that = this;
                setTimeout(function() { //Non blocking for performance optimization.
                    var mappings = _.clone(masterJson[CT.settings.currentTab].mapping);
                    _.each(mappings, function(mapping, sectorIndex) {
                        var i = 1;
                        that.flightRanks[sectorIndex] = [];
                        mapping = _.sortBy(mapping, function(map) {
                            return Number(map.content[0].dp.replace(":", ""))
                        });
                        mapping = _.sortBy(mapping, function(map) {
                            if (map.fare[map.fare.dfd])
                                return map.fare[map.fare.dfd].pr;
                            else {
                                if (map.fare.SPLRT)
                                    return map.fare.SPLRT[0][map.fare.SPLRT[0].dfd].pr;
                            }
                        })
                        var prevMap;
                        _.each(mapping, function(map) {
                            if (prevMap && prevMap.fare[prevMap.fare.dfd] && map.fare[map.fare.dfd] && prevMap.fare[prevMap.fare.dfd].pr == map.fare[map.fare.dfd].pr) {
                                i--;
                                i = i + .01;
                            } else i = Math.floor(i);
                            map.priceRank = i.toFixed(2);
                            prevMap = map;
                            i++;
                            that.flightRanks[sectorIndex].push(map.priceRank);
                        })
                    });
                }, 1000);

            } catch (e) {
                window.ct_debug && window.console.log(e);
            }
        },
        flightRanks: {}
    }

});
